module.exports = __webpack_public_path__ + "img/qbert_questions_p8.d6bf4c1a.jpg";